import { Action } from '../actions';

const initialState: Cockpit.Store = {
  isLogin: false,
  id: 'me',
  screens: [],
  screensLoading: true,
  setting: {
    welcomeLogo: '',
    homeLogo: ''
  }
};

export function Store(state: any = initialState, action: Cockpit.Action) {
  switch (action.type) {
    case Action.INIT:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
